import { Form, Modal } from 'antd'
import { useRef, useState } from 'react'
import { SL_Input } from '../../../components/input/Input'
import { displayMessage } from '../../../helpers/messages'
import api from '../../../services/api'

const STATUS_SUCCESS = 200

export function ModalCreateAffectedPillar({ isOpen, onClose, reloadAffectedPillars }) {
    const formRef = useRef()

    const [loading, setLoading] = useState(false)

    const onSubmit = async affected_pillar => {
        setLoading(true)
        try {
            const response = await api.affectedPillars.create(affected_pillar)

            if (response.status === STATUS_SUCCESS) {
                onClose(false)
                await reloadAffectedPillars()
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            title={displayMessage('AFFECTED_PILLAR_CREATION')}
            centered
            open={isOpen}
            onOk={() => formRef.current.submit()}
            confirmLoading={loading}
            onCancel={() => onClose(false)}
            okText={displayMessage('FINISH')}
            maskClosable={false}
        >
            <Form onFinish={onSubmit} className="max-w-[700px] w-full" layout="vertical" requiredMark={false} ref={formRef}>
                <div className="flex flex-col gap-1">
                    <div className="">{displayMessage('TITLE')}</div>

                    <Form.Item name="title" rules={[{ required: true, message: displayMessage('DISPLAY_TILE') }]} className="mb-4">
                        <SL_Input placeholder={displayMessage('TITLE')} className={'w-full'} />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}
